// import React from "react";
// import "./LoaderAction.css";

// export default function App() {
//   return <div className="loader"></div>;
// }
import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import LoadGif from "../img-load/Loading.gif";
// import "./styles.css";
// import MemesList from "./MemesList";
import "./Loading.scss";
export default function App({ textColor }) {
  const [memes, setMemes] = useState({});
  const [isLoding, setIsLoding] = useState(true);
  const [tColor, setTColor] = useState(textColor ? textColor : "#12349F");

  useEffect(() => {
    // fetch("https://api.imgflip.com/get_memes")
    //   .then((res) => res.json())
    //   .then((data) => setMemes(data));
    // setTimeout(() => {
    //   setIsLoding(false);
    // }, 100000);
  }, []);

  return (
    <div className="App">
      {isLoding ? (
        <>
          <LoadingScreen
            loading={true}
            // bgColor="#f1f1f1"
            // spinnerColor="#ED1C24"
            // textColor={tColor ? tColor : "#ED1C24"}
            // logoSrc={spinner}
            // logoSrc="https://loading.io/icon/jr8r2s"
            logoSrc={LoadGif}
            // text="กำลังอัพเดตข้อมูล..."
          />
          <div className="overlay" />
        </>
      ) : (
        ""
      )}
    </div>
  );
}
